@if (activeSection(); as section) { @if (section.type === 'subscription') { @if (currentSubscription(); as subscription)
{
<div>
	@if (subscription) {
	<lib-card [title]="'Manage your subscription'" [subtitle]="'Status: ' + subscription.status">
		<div [libFlexRow]="isMobileView()" [libFlexRowAlign]="'start'" [libFlexRowGap]="'16px'">
			@if (subscription.status === 'active') {
			<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
				<lib-link
					[linkStyle]="'noUnderline'"
					[externalUrl]="subscription.paymentUpdateUrl"
					[routerLink]="undefined"
				>
					<lib-button [buttonType]="'basic'">Update payment</lib-button>
				</lib-link>
			</div>
			<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
				<lib-link
					[linkStyle]="'noUnderline'"
					[externalUrl]="subscription.cancelationUrl"
					[routerLink]="undefined"
				>
					<lib-button [buttonType]="'delete'">Cancel</lib-button>
				</lib-link>
			</div>
			} @else if (subscription.status === 'canceled'){
			<span>Your subscription has been canceled</span>
			}
		</div>
	</lib-card>
	}
</div>

}

<mod-pricing-card
	[class.push-top-md]="currentSubscription() ? true : false"
	[buttonBehavior]="'subscribe'"
	(handleSubscribe)="handleSubscribe($event)"
>
</mod-pricing-card
>} @else if (section.type === 'checkout') {

<div libFlexRow [libFlexRowAlign]="'start'">
	<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
		<lib-button
			[buttonType]="'basic'"
			[icon]="'goBack'"
			(click)="activeSection.set({ type: 'subscription', pricingInterval: section.pricingInterval })"
			>Go back</lib-button
		>
	</div>
</div>
<div class="push-top-md">
	<mod-checkout [pricingInterval]="section.pricingInterval"></mod-checkout>
</div>

} @else {
<lib-message [type]="'warning'">Invalid section </lib-message>
} }
